import * as Sentry from '@sentry/vue';

// Telemetry helpers. Diagnostic events are sent through the Sentry SDK, which is
// configured in main.ts to deliver to BetterStack via its DSN (same approach as
// the main UI). The iOS memory tab-kill is silent — no JS error is thrown — so
// we emit explicit events (reload counter, queue size) as the signal; Sentry
// auto-captures genuine exceptions separately.

type Fields = Record<string, unknown>;
type Level = 'info' | 'warning' | 'error';

export const logToBetterStack = (message: string, fields: Fields = {}, level: Level = 'info'): void => {
  try {
    Sentry.captureMessage(message, { level, extra: fields });
  } catch {
    /* never let telemetry break the app */
  }
};

// usedJSHeapSize in MB, or null where the browser doesn't expose it (Safari/iOS).
export const heapMB = (): number | null => {
  const mem = (performance as unknown as { memory?: { usedJSHeapSize: number } }).memory;
  return mem ? Math.round(mem.usedJSHeapSize / 1048576) : null;
};
